import apiClient from '../../api/index';
import {
  GetUserMachinesGroupsResponse,
  IMachinesGroupsService
} from './contracts/machinesGroups.service';

export const MachinesGroupsService: IMachinesGroupsService = {
  async getUserMachinesGroups(): Promise<GetUserMachinesGroupsResponse> {
    const response = await apiClient.request('GET', '/v2/machines-group/me');
    return response.data as GetUserMachinesGroupsResponse;
  }
};
